module.exports = __webpack_public_path__ + "img/home-hashtag.2d01ba80.svg";